/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AnswersControllerFindAllQueryResponse, AnswersControllerFindAllQueryParams, AnswersControllerFindAll401, AnswersControllerFindAll403 } from "../../models/checklistsController/AnswersControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { answersControllerFindAll } from "../../clients/checklistsService/answersControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const answersControllerFindAllQueryKey = (params: AnswersControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-answers'
}, ...(params ? [params] : [])] as const;
export type AnswersControllerFindAllQueryKey = ReturnType<typeof answersControllerFindAllQueryKey>;
export function answersControllerFindAllQueryOptions(params?: AnswersControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = answersControllerFindAllQueryKey(params);
  return queryOptions<AnswersControllerFindAllQueryResponse, ResponseErrorConfig<AnswersControllerFindAll401 | AnswersControllerFindAll403>, AnswersControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return answersControllerFindAll(params, config);
    }
  });
}

/**
 * @description This endpoint supports a higher page size limit of 1000 (default is 100). Use `page[size]=1000` to retrieve up to 1000 records per request.
 * @summary Get all checklist answers
 * {@link /api/v1/checklist-answers}
 */
export function useAnswersControllerFindAll<TData = AnswersControllerFindAllQueryResponse, TQueryData = AnswersControllerFindAllQueryResponse, TQueryKey extends QueryKey = AnswersControllerFindAllQueryKey>(params?: AnswersControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<AnswersControllerFindAllQueryResponse, ResponseErrorConfig<AnswersControllerFindAll401 | AnswersControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? answersControllerFindAllQueryKey(params);
  const query = useQuery({
    ...answersControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AnswersControllerFindAll401 | AnswersControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}